import styled from 'styled-components';
import MaterialAvatar from '@material-ui/core/Avatar';
import { TABLET_WIDTH } from 'constants/breakPoints';

export const BackArrow = styled.div`
  display: inline-block;
  width: 50px;
  vertical-align: middle;

  i {
    color: #666;
    cursor: pointer;
    font-size: 16px;
  }
`;
export const InvitationsListWrapper = styled.div`
  display: block !important;
  flex-direction: unset !important;
  height: 100%;
  width: 100%;
  background-color: ${props => props.color};
  overflow: auto;

  @media (max-width: ${TABLET_WIDTH}px) {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 300;
    height: 100%;
    width: 100%;
  }

  .no_elements {
    margin: 0px;

    div {
      color: #666;
      font-size: 18px;
      margin-top: 20px;
    }
  }
`;

export const InvitationsListHeader = styled.div`
  display:flex;
  background-color: #fff;
  padding: 0px 10px;
  width: 100%;
  margin: 0 auto;
  height: calc(60px + env(safe-area-inset-top));
  padding-top: env(safe-area-inset-top);
  line-height: 50px;
  border-bottom: 1px solid #eee;
  font-size: 20px;
  font-weight: 600;
  align-items: center;
`;

export const InvitationsList = styled.div`
  width: 100%;
  z-index: 1;
  height: calc(100vh - 110px);
  background-color: #f5f5f5;

  @media (max-width: ${TABLET_WIDTH}px) {
    height: calc(100vh - 60px - env(safe-area-inset-top));
  }
`;


export const Invitation = styled.div`
  padding: 15px;
  background-color: #fafafa;
  border-bottom: 1px solid #eee;
  position: relative;
  display: flex;
  align-items: center;
  font-size: 14px;

  .avatar_bubble {
    margin-right: 10px;
  }
`;

export const AvatarWrapper = styled.div`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 80px;
`;

export const UserAvatar = styled(MaterialAvatar)`
   && {
    width: 60px;
    height: 60px;
    display: inline-block;

    img {
      object-fit: contain;
      background-color: #eee;
    }

    &.text-avatar {
      font-size: 28px;
      padding-top: 13px;
      text-align: center;
    }
   }
`;

export const UserContent = styled.div`
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 80px);
`;

export const UserName = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #444;
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'helvetica neue';
  display: inline-block;
  width: calc(100% - 60px);
`;
export const ButtonsWrapper = styled.div`
   position: relative;
   right: 0;
   display:flex;
   justify-content: space-evenly;
   max-width: 50%;
   padding-left: 2rem;
`;

export const InvitationText = styled.div`
   max-width: 25%;
   overflow-wrap: break-word;
`;

export const ButtonInvite = styled.button`
  background: ${props => props.color};
  padding: 1.2rem 2rem;
  border-radius: 2rem;
  color: white;
`;



// WEBPACK FOOTER //
// ./src/routes/Invitations/components/styles.js